import React, { useEffect, useMemo, useState } from 'react';
import { Slider } from '@assets/spa/slider';
import { Select } from '@assets/spa/control/select';
import { Control } from '@assets/spa/control/text';
export default function GreenKilometers({ prefetch, containers_label, savings_label, trailers_label }) {
    var _a, _b;
    const { routes } = prefetch || {};
    const [route, setRoute] = useState(0);
    const [koef1, setKoef1] = useState((_a = routes[route]) === null || _a === void 0 ? void 0 : _a.koef_1);
    const [koef2, setKoef2] = useState((_b = routes[route]) === null || _b === void 0 ? void 0 : _b.koef_2);
    const [koef1Slider, setKoef1Slider] = useState(0);
    const [koef2Slider, setKoef2Slider] = useState(0);
    useEffect(() => {
        var _a, _b;
        setKoef1((_a = routes[route]) === null || _a === void 0 ? void 0 : _a.koef_1);
        setKoef2((_b = routes[route]) === null || _b === void 0 ? void 0 : _b.koef_2);
    }, [route]);
    const val1 = koef1Slider * koef1;
    const val2 = koef2Slider * koef2;
    const savings = parseFloat((val1 + val2).toFixed(1));
    const selectOptions = useMemo(() => routes.map((r, i) => ({ value: `${i}`, label: r.label })), [routes]);
    return React.createElement(React.Fragment, null,
        React.createElement(Select, { options: selectOptions, value: route.toString(), onChange: (val) => setRoute(parseInt(val)) }),
        React.createElement("h4", null,
            trailers_label,
            ": ",
            koef1Slider),
        React.createElement(Slider, { from: 0, to: 100, instant: true, onChange: (val) => { setKoef1Slider(val); }, snap: true, step: 1, value: koef1Slider }),
        React.createElement("h4", null,
            containers_label,
            ": ",
            koef2Slider),
        React.createElement(Slider, { from: 0, to: 100, instant: true, onChange: (val) => { setKoef2Slider(val); }, snap: true, step: 1, value: koef2Slider }),
        React.createElement("h4", null, savings_label),
        React.createElement(Control, { value: savings.toString(), disabled: true }));
}
